module.exports = __webpack_public_path__ + "img/csr12.51e2ffe8.jpg";